import { render } from "./settings-controllers-SimpleZeroInjection.vue?vue&type=template&id=6eeb96fe"
import script from "./settings-controllers-SimpleZeroInjection.vue?vue&type=script&lang=js"
export * from "./settings-controllers-SimpleZeroInjection.vue?vue&type=script&lang=js"

import "./settings-controllers-SimpleZeroInjection.vue?vue&type=style&index=0&id=6eeb96fe&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__